import { render, staticRenderFns } from "./StorageCard.vue?vue&type=template&id=066d399b&scoped=true&"
import script from "./StorageCard.vue?vue&type=script&lang=js&"
export * from "./StorageCard.vue?vue&type=script&lang=js&"
import style0 from "./StorageCard.vue?vue&type=style&index=0&id=066d399b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d399b",
  null
  
)

export default component.exports